import { PocButton, PocInput } from 'commons/components/components-wrapper';
import styled from 'styled-components';
import { AssistiveTextLayout } from '../form-elements';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const InputWrapper = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`;

export const UploadOwcInput = styled(PocInput).attrs({
    size: 'small',
    variant: 'outlined',
})`
    /* OWC-OVERRIDE: fill the row. owc-input has a fixed ~250px default width on its host and
       no width prop in v7.6.0; matching its own class raises specificity enough to win. */
    &.owc-input {
        flex: 1;
        width: 100%;
    }
`;

export const BrowseButton = styled(PocButton)`
    flex-shrink: 0;
    white-space: nowrap;
`;

export const UploadAssistiveTextLayout = styled(AssistiveTextLayout)`
    padding-left: 1rem;
`;
